import http from "../utils/http-common";

class BankDataService {
  async getAll() {
    const resp = await http.get("/bank");
    resp.data.rows = resp.data.rows.map((r) => { return { ...r, name: r.name + ` (${r.rate})` } })
    return resp;
  }

  get(id) {
    return http.get(`/bank/${id}`);
  }

  create(data) {
    return http.post("/bank", data);
  }

  update(id, data) {
    return http.put(`/bank/${id}`, data);
  }

  delete(id) {
    return http.delete(`/bank/${id}`);
  }
}

export default new BankDataService();